export default __webpack_public_path__ + "static/media/rain.5b49b6ad.ogg";